import { Component, input, output, signal } from '@angular/core';
import { Dropdown, DropdownOption } from '@ntv360/component-pantry';

@Component({
    selector: 'app-dropdown',
    imports: [Dropdown],
    templateUrl: './dropdown.component.html',
    styleUrl: './dropdown.component.scss',
})
export class DropdownComponent {
    /** Dropdown placehold */
    public placeholder = input<string>('');

    /** Dropdown options */
    public options = input.required<DropdownOption[]>();

    /** Holds the selected dropdown value */
    protected selectedValue = signal<string | null>(null);

    /** Emits the selected value */
    public selectionChange = output<DropdownOption | null>();

    /**
     * Handles the selection change event from the dropdown
     * @param event - The selected value
     */
    protected onSelectionChange(event: DropdownOption | null): void {
        this.selectedValue.set(event?.label ?? null);
        this.selectionChange.emit(event);
    }

    /** Clears the selected value and notifies the parent so its filter state resets too */
    protected clearSelection(): void {
        this.selectedValue.set(null);
        this.selectionChange.emit(null);
    }
}
